import type { Schema } from '@cli-types/core-engine/schema.js'
import { getManyToManyFields } from '@core-engine/schema/field-helpers/flattening/get-many-to-many-fields.js'
import { loadSchema } from '@core-engine/schema/schema-reader/load-schema.js'
import { isSystemRelationshipTarget } from '@core-engine/schema/system-relationships/is-system-relationship-target.js'

export function loadRelationshipSchemas(
  schema: Schema,
  cwd: string,
  schemasDir: string
): Map<string, Schema> {
  const targets = new Set(
    getManyToManyFields(schema.fields)
      .map((field) => field.relationship)
      .filter((relationship): relationship is string => Boolean(relationship))
  )

  const relatedSchemas = new Map<string, Schema>()
  for (const relationship of targets) {
    if (isSystemRelationshipTarget(relationship)) {
      continue
    }

    const loaded = loadSchema(`${cwd}/${schemasDir}`.replace(/\/+/g, '/'), relationship)
    if (loaded.type === 'form') {
      throw new Error(
        `Relationship "${schema.name}" -> "${relationship}" cannot target a form schema.`
      )
    }
    relatedSchemas.set(relationship, loaded.schema)
  }

  return relatedSchemas
}
